import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

export default function Home() {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const basePath = process.env.PUBLIC_URL || '';
    fetch(`${basePath}/data/profile.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => setProfile(data))
      .catch(error => console.error('Error fetching profile data:', error));
  }, []);

  if (!profile) {
    return null;
  }

  return (
    <div className="home-container">
      <div className="profile-grid">
        <aside className="profile-card">
          <img src={`${process.env.PUBLIC_URL}/headshot-portrait.jpeg`} alt="Ian Whitesel" className="headshot" />
          <h1>{profile.greeting}</h1>
          <p className="tagline">{profile.tagline}</p>
          <div className="buttons">
            <Link to="/resume" className="btn">View Resume</Link>
            <Link to="/projects" className="btn btn-outline">Side Projects</Link>
            <Link to="/contact" className="btn btn-outline">Contact Me</Link>
          </div>
          <div className="skills-block">
            <h2>Key Skills</h2>
            <ul className="skills-list">
              {profile.skills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>
        </aside>

        <div className="about-me-section">
          {profile.aboutMe.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
